
import React, { useState, useEffect, useRef } from 'react';
import { withTranslation } from "react-i18next";
import ReportAIService from '../../core/service/ReportAIService';
import './AIChatWidget.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Utils from '../../core/utilities/Utils';
import { BsArrowRepeat } from "react-icons/bs";
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import { BiX } from "react-icons/bi";

const AIChatHistory = ({ t, companyId, userId, handleClose, onHistoryDataClick }) => {
    const [historyData, setHistoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [startLimit, setStartLimit] = useState(0);
    const [endLimit, setEndLimit] = useState(5);
    const containerRef = useRef(null);
    const [showConfirmation, setShowConfirmation] = useState(false);
    let messageConfirmation = t("DeleteChatHistoryMessage.label");

    useEffect(() => {
        fetchChatHistory();

    }, [companyId, userId, startLimit, endLimit]);

    const fetchChatHistory = () => {
        setIsLoading(true);
        ReportAIService.getHistory(companyId, userId, startLimit, endLimit)
            .then(response => {
                if (response.status === 200) {
                    const fetchedData = response.data;
                    if (fetchedData.length > 0) {
                        const indexedHistory = indexChatHistory(fetchedData);
                        setHistoryData(prevData => [...prevData, ...indexedHistory]);
                        setStartLimit(prevStart => prevStart + 5);
                        setEndLimit(prevEnd => prevEnd + 5);
                    }
                } else {
                    console.error('Error fetching chat history:', response.statusText);
                }
            })
            .catch(error => {
                console.error('Error fetching chat history:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const deleteChatHistory = () => {
        ReportAIService.deleteChatHistory(companyId, userId)
            .then(response => {
                if (response.status === 200) {
                    // If successful, update chat history state or perform any necessary actions
                    setHistoryData([]);
                } else {
                    console.error('Error deleting chat history:', response.statusText);
                }
            })
            .catch(error => {
                console.error('Error deleting chat history:', error);
            });
    };

    const indexChatHistory = (history) => {
        return history.map(item => ({
            createdDate: new Date(item.created_at),
            data: item
        }));
    };

    const formatDate = (date) => {
        return Utils.formatDate(date);
    };

    // Filter historyData to get entries for today's date
    const todayEntries = historyData.filter(entry => {
        const formattedDate = formatDate(entry.createdDate);
        const currentDate = formatDate(new Date());
        return formattedDate === currentDate;
    });

    const confirmDelete = (val) => {
        setShowConfirmation(false);
        if (val) {
            deleteChatHistory();
        }
    };

    const showConfirm = () => {
        setShowConfirmation(true);
    }

    return (
        <div className='widget-Chat_historyBox' ref={containerRef}>
            <div className='widget-body_Chat_historyBox'>
                <div className='Chat_historyBox_head'>
                    <div className='Chat_historyBox_head_inner'>
                        <h6>History</h6>
                        <div className='Chat_History_close'>
                            <ul>
                                <li>
                                    <button
                                        type="button"
                                        className="history-clear-button"
                                        onClick={showConfirm}
                                        aria-label="Clear history"
                                    >
                                        <BsArrowRepeat className='me-1' /> Clear
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='Chat_historyFooter_inner'>
                        <input type='text' className='form-control' placeholder='Search' />
                    </div>
                </div>
                <div className='Chat_historyBox'>

                    {/* <div className='Chat_history_allDate'>
                        <div className='date_view'>today</div>
                        <OverlayTrigger
                            placement="auto"
                            overlay={<Tooltip id="tooltip-like">Ask a </Tooltip>} >
                            <div className='Chat_history_qusBox'>
                                <div className='Chat_history_qus_head'>
                                    <h6>Ask a question related to the data available in the application or an uploaded ESG File. ESGAI® Copilot Chat With Data response can include key data points, trends, summaries, complex data analysis etc.</h6>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div> */}


                    {Object.entries(historyData.reduce((acc, entry) => {
                        const formattedDate = formatDate(entry.createdDate);
                        if (!acc[formattedDate]) {
                            acc[formattedDate] = [];
                        }
                        acc[formattedDate].push(entry);
                        return acc;
                    }, {})).map(([date, entries]) => (
                        <div key={date} className='Chat_history_allDate'>
                            <div className='date_view'>{date}</div>
                            {/* Render entries for the current date */}
                            {entries.map(entry => (
                                entry.data && (
                                    <OverlayTrigger
                                        placement="auto"
                                        overlay={<Tooltip id="tooltip-like">{entry.data.user_query} </Tooltip>} >
                                        <div key={entry.createdDate.getTime()} className='Chat_history_qusBox'>
                                            <div className='Chat_history_qus_head'>
                                                <button
                                                    type="button"
                                                    className="history-query-button"
                                                    onClick={() => onHistoryDataClick(entry.data)}
                                                    aria-label={`Select query: ${entry.data.user_query}`}
                                                >
                                                    {entry.data.user_query}
                                                </button>
                                            </div>
                                        </div>
                                    </OverlayTrigger>
                                )
                            ))}
                        </div>
                    ))}
                    {/* Render loading indicator if isLoading */}
                    {isLoading && <p>Loading...</p>}
                    {/* Render 'No History found!' message if no historyData */}
                    {/* {!isLoading && historyData.length === 0 && <p className='no-Found'>No History found!</p>} */}
                </div>
            </div>
            {/* <div className='widget-Chat_historyFooter'>
                <div className='Chat_historyFooter_inner'>
                    <Button variant="Close_history" className='mx-2' onClick={handleClose}>Close History</Button>
                    <span className="btn-Clear_history" onClick={deleteChatHistory}><BsArrowRepeat className='me-1' /> Clear</span>
                </div>
            </div> */}
            {showConfirmation && (
                <ConfirmationModal
                    modalShow={true}
                    messageText={messageConfirmation}
                    callbackModal={confirmDelete}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            )}
        </div>

    );

};

export default withTranslation()(AIChatHistory);

